"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const react_1 = require("@emotion/react");
const FormHelperText_1 = tslib_1.__importDefault(require("@mui/material/FormHelperText"));
const Typography_1 = tslib_1.__importDefault(require("../../Typography"));
const LabelBase = ({ hasError, label, description, errorMessage }) => {
    const theme = (0, react_1.useTheme)();
    if (label && typeof label !== 'string') {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [label, hasError && (0, jsx_runtime_1.jsx)(FormHelperText_1.default, Object.assign({ error: true }, { children: errorMessage }))] }));
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [label && (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ size: 'xxs' }, { children: label })), description && ((0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ size: 'xxs', weight: 'regular' }, { children: description }))), hasError && ((0, jsx_runtime_1.jsx)(FormHelperText_1.default, Object.assign({ sx: { fontSize: theme.font.size.xxxs }, error: true }, { children: errorMessage })))] }));
};
exports.default = React.memo(LabelBase);
